/** Tipos y constantes de dominio compartidos por web y API. */
export const LANGUAGES = ['es', 'en'];
export const LAYOUT_IDS = ['es-qwerty', 'en-qwerty'];
export const DEFAULT_LAYOUT = {
    es: 'es-qwerty',
    en: 'en-qwerty',
};
/** Fuente del texto de una prueba. */
export const TEST_MODES = [
    'words',
    'phrases',
    'texts',
    'numbers',
    'punctuation',
    'symbols',
    'custom',
    'letters',
    'combos',
    'weak',
];
/** Contexto en el que se realiza una prueba. */
export const TEST_KINDS = ['test', 'practice', 'lesson', 'challenge', 'race'];
/** Duraciones estándar (segundos) que participan en rankings. */
export const RANKED_DURATIONS = [15, 30, 60, 120];
export const MIN_CUSTOM_DURATION = 5;
export const MAX_CUSTOM_DURATION = 600;
export const WORD_COUNT_OPTIONS = [10, 25, 50, 100];
export const MAX_WORD_COUNT = 500;
export const SKILL_TIERS = ['beginner', 'basic', 'intermediate', 'advanced', 'expert'];
export const ROLES = ['user', 'editor', 'admin', 'superadmin'];
export function isLanguage(value) {
    return typeof value === 'string' && LANGUAGES.includes(value);
}
export function isRankedDuration(value) {
    return typeof value === 'number' && RANKED_DURATIONS.includes(value);
}
//# sourceMappingURL=types.js.map